<template>
    <div class="as-advanced_selector">
        <as-selector @click.native="onShowDialog" :label="label" :default="selectViewData"></as-selector>
        <as-dialog-selector
            ref="dialogSelector"
            v-model="dialogVisible"
            :loading="dialogLoading"
            :sidebar-list="sidebarData"
            :data="selectorData"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem"
            v-on="$listeners"
            v-bind="$attrs">
        </as-dialog-selector>
    </div>
</template>

<script>
    import AsSelector from '@/components/selector';
    import AsDialogSelector from '@/components/dialog-selector'
    export default {
        name: 'AsAdvancedSelector',
        components: {
            AsSelector,
            AsDialogSelector,
        },
        props: {
            label: String,
            loadData: Function,
            options: Array,
            sidebarList: Array,
            placeholder: {
                type: String,
                default: '请选择',
            },
            clearable: Boolean,
            defaultCheckedKeys:{
                type:Array,
                default: () => [] ,
            },
            defaultSelectViewData:{
                type:Array,
                default: () => [] ,
            }
        },
        data() {
            return {
                dialogSelector: null,
                dialogVisible: false,
                dialogLoading: false,
                loadSidebarData: null,
                loadSelectorData: null,
                selectListData: null,
                // defaultCheckedKeys: [],
            }
        },
        computed: {
            defaultSelectData() {
                return {
                    name: this.placeholder
                }
            },
            selectViewData() {
                if (!this.dialogSelector) return this.defaultSelectData;
                const { label } = this.dialogSelector.contentProps;
                const count = this.selectListData ? this.selectListData.length : 0;
                if (!count) return this.defaultSelectData;
                const appendFixLabel = count > 1 ? `+ ${count - 1}` : '';
                const name = `${this.selectListData[0][label]}${appendFixLabel}`;
                return {
                    name,
                }
            },
            sidebarData() {
                return this.loadData ? this.loadSidebarData : this.sidebarList;
            },
            selectorData() {
                return this.loadData ? this.loadSelectorData : this.options;
            }
        },
        methods: {
            onShowDialog() {
                this.dialogVisible = true;
                if (this.loadData) {
                    this.dialogLoading = true;    
                    this.loadData(this.loadDataCallback);
                    return;
                }
            },
            loadDataCallback(data, sidebarList) {
                this.dialogLoading = false;
                this.loadSelectorData = data;
                this.loadSidebarData = sidebarList;
                this.dialogSelector = this.$refs.dialogSelector;
            },
            onConfirm(nodeList) {
                this.selectListData = nodeList.filter(item => !!item);
                this.triggerEvent(this.selectListData);
            },
            onSelectItem(data) {
                const nodeList = [ data ];
                this.selectListData = nodeList;
                this.triggerEvent(nodeList);
            },
            triggerEvent(nodeList) {
                // this.defaultCheckedKeys = nodeList.map(item => item.id);
                this.$emit('change', nodeList,this.selectViewData);
            },
            clear() {
                this.selectListData = [];
                this.triggerEvent([]);
            }
        }
    }
</script>
<style lang="scss">
.as-advanced_selector {
    display: inline-flex;
}
</style>